import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

const STORAGE_KEY = "sgc.mapBaseLayer";

const MapSettingsContext = createContext(null);

function normalizeBaseLayer(value) {
  const v = String(value ?? "")
    .toLowerCase()
    .trim();
  if (v === "grises") return "grises";
  if (v === "topografico" || v === "topográfico") return "topografico";
  if (v === "calles") return "calles";
  if (v === "satelite" || v === "satélite") return "satelite";
  return "calles";
}

export function MapSettingsProvider({ children }) {
  const [baseLayer, setBaseLayerState] = useState(() => {
    if (typeof window === "undefined") return "calles";
    try {
      return normalizeBaseLayer(window.localStorage.getItem(STORAGE_KEY));
    } catch {
      return "calles";
    }
  });

  const setBaseLayer = useCallback((next) => {
    const normalized = normalizeBaseLayer(next);
    setBaseLayerState(normalized);
    if (typeof window === "undefined") return;
    try {
      window.localStorage.setItem(STORAGE_KEY, normalized);
    } catch {
      // ignore
    }
  }, []);

  const value = useMemo(
    () => ({ baseLayer, setBaseLayer }),
    [baseLayer, setBaseLayer],
  );

  return (
    <MapSettingsContext.Provider value={value}>
      {children}
    </MapSettingsContext.Provider>
  );
}

export function useMapSettings() {
  const ctx = useContext(MapSettingsContext);
  if (!ctx) {
    throw new Error("useMapSettings must be used within MapSettingsProvider");
  }
  return ctx;
}
